/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as ActionTypes from './actionTypes';
import { riderData } from './data';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING,
  isLoading: value,
});

export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_INPUT_RIDER,
  payload: data,
});

export const setRiderReportData = (data) => ({
  type: ActionTypes.GET_RIDER_REPORT,
  payload: data,
});

export const dispatchRebatePrograme = (data) => ({
  type: ActionTypes.GET_REBATE_PROGRAM_RIDER,
  payload: data,
});
export const refreshRider = () => ({
  type: ActionTypes.REFRESH_RIDER_REPORT,
  payload: {},
});
export const refreshRiderDisplay = () => ({
  type: ActionTypes.REFRESH_RIDER_REPORT_DISPLAY,
  payload: {},
});
export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

//API to get Reabte Program List
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data.data;
    })
    .catch((response) => {});
};
export const nodaFound = () => (dispatch) => {
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
  // setTimeout(() => {
  //   dispatch(
  //     setSearchInput({
  //       errors: [],
  //     })
  //   );
  // }, 5000);
};

export const setPaginationIndex = (value) => ({
  type: ActionTypes.SET_PAGINATION_INDEX_RIDER,
  payload: value,
});
// API to get RiderReports data
export const getReportData = (values) => (dispatch) => {
  dispatch(setLoading(true));
  setRiderReportData({});
  return axios
    .post(serviceEndPoint.GET_RIDER_REPORT, values)
    .then((response) => {
      dispatch(setLoading(false));
      const searchResult = response?.data?.riderReportWrapperVO;
      if (
        searchResult?.reportByYear?.length > 0 ||
        searchResult?.reportByAllRpc?.length > 0 ||
        searchResult?.reportByIndividualRpc?.length > 0
      ) {
        dispatch(setRiderReportData(response?.data?.riderReportWrapperVO));
      } else {
        dispatch(nodaFound());
      }
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setRiderReportData({}));
    });
};

// export const getReportData = (values) => (dispatch) => {
//   dispatch(setLoading(true));
//   const data = riderData.riderReportWrapperVO;
//   dispatch(setLoading(false));
//   dispatch(setRiderReportData(data));
// };
